import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import {MatTableDataSource} from "@angular/material/table"
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/features/authmanagement/services/Auth.service';
@Component({
  selector: "userpage",
  templateUrl: "./userPage.component.html",
  styleUrls: ["./userPage.component.css"],
})
export class UserPageComponent implements OnInit {
  isLoadingPanel: boolean;
  public isAuthenticated: boolean = false;

  
  DataSource: MatTableDataSource<unknown>;
  Columns: string[] = ["UUID", "UserName", "Nombre", "Apellido Paterno","Apellido Materno","Rol"];
  Actions: string[] = ["Enlazar"];
  Data: any;
  pageSizeOptions = [10, 20, 20];
  resultsLength = 0;
  isLoadingResults = true;
  hasActions = true;
  isFilterVisible;
  roles: string;
  isAdmin: boolean = false;
  isSuperuser: boolean = false;
  

  subscription_GetLoading: Subscription;
  subscription_CheckAuthentication: Subscription;
  public isAllowed: boolean;

  constructor(
    private authService: AuthService
  ) {
    this.isFilterVisible = false;   
    this.isAllowed = false;
  }

  ngOnInit(): void {
    this.CheckAuthentication();
  }



  ngOnDestroy() {
    if (this.subscription_GetLoading)
    this.subscription_GetLoading.unsubscribe();
    if(this.subscription_CheckAuthentication) this.subscription_CheckAuthentication.unsubscribe();

  }
  

  CheckAuthentication() {
    this.subscription_CheckAuthentication = this.authService
      .checkAuthenticated()
      .subscribe((arg) => {
        this.isAuthenticated = arg;
      });
    console.log("Authenticated:" + this.isAuthenticated);
  }

   showFiltersCallback(event) {
    console.log("Received");
    // this.filterDialogRef = this.dialog.open(UsersFiltersComponent, {
    //   width: "350px",
    //   position: { right: "0" },
    //   height: "100vh",
    //   data: { download: false },
    // });
  }


filterCallback(filtro){
  // console.log(this.DataSource);
  // this.DataSource.filter = filtro.trim().toLowerCase();
}

}